import styled from 'styled-components';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const AddressSuggestion = styled.div`
    display: block;
    width: 100%;
    ${FONTS.sans.regular.size17};
`;